"use client";

import { c as _c } from "react/compiler-runtime";
import { FaqType } from "@/graphql/queries/faqs-query";
import { useParams, usePathname } from "next/navigation";
export const useFaqParams = () => {
  const $ = _c(5);
  const {
    course,
    slug,
    country,
    city
  } = useParams();
  const pathname = usePathname();
  let faqType = FaqType.GENERAL;
  if (pathname.includes(course)) {
    faqType = FaqType.COURSES;
  }
  if (pathname.includes(slug)) {
    faqType = FaqType.CONSULTING;
  }
  const t0 = faqType as FaqType;
  const t1 = course || slug;
  let t2;
  if ($[0] !== city || $[1] !== country || $[2] !== t0 || $[3] !== t1) {
    t2 = {
      faqType: t0,
      slug: t1,
      country,
      city
    };
    $[0] = city;
    $[1] = country;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};